export default "__VITE_ASSET__CtV5Ryhn__"